import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="bg-[#0B192C] text-white/80 relative overflow-hidden noise mt-20"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-6 gap-10 px-6 md:px-10 py-16 relative">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-2 mb-4">
                        <div className="w-9 h-9 rounded-xl bg-[#F5A623] flex items-center justify-center">
                            <span className="text-[#0B192C] font-black text-lg font-display">
                                R
                            </span>
                        </div>
                        <div className="font-display text-xl font-black text-white">
                            Renforteo
                        </div>
                    </div>
                    <p className="text-sm text-white/60 max-w-md leading-relaxed">
                        La plateforme lyonnaise de renfort professionnel : restauration, hôtellerie,
                        événementiel, nettoyage et logistique. Professionnels indépendants vérifiés,
                        devis TTC instantané, paiement sécurisé.
                    </p>
                    <div className="mt-5 text-xs text-white/50 leading-relaxed">
                        Renforteo — 41 rue Jean Moulin, 69300 Caluire-et-Cuire<br />
                        SIRET 521 636 167 00046 · contact@renforteo.fr
                    </div>
                </div>
                <div>
                    <div className="overline text-white/60 mb-4">Plateforme</div>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/entreprises" className="hover:text-[#F5A623]" data-testid="footer-entreprises-link">
                                Renforteo Entreprises
                            </Link>
                        </li>
                        <li>
                            <Link to="/devis" className="hover:text-[#F5A623]" data-testid="footer-quote-link">
                                Estimer ma mission
                            </Link>
                        </li>
                        <li>
                            <Link to="/professionnels" className="hover:text-[#F5A623]" data-testid="footer-find-mission-link">
                                Trouver une mission
                            </Link>
                        </li>
                        <li>
                            <Link to="/comment-ca-marche" className="hover:text-[#F5A623]" data-testid="footer-how-link">
                                Comment ça marche
                            </Link>
                        </li>
                        <li>
                            <Link to="/blog" className="hover:text-[#F5A623]" data-testid="footer-blog-link">
                                Blog &amp; guides
                            </Link>
                        </li>
                        <li>
                            <Link to="/verifications" className="hover:text-[#F5A623]" data-testid="footer-verif-link">
                                Vérifications
                            </Link>
                        </li>
                        <li>
                            <Link to="/assistance" className="hover:text-[#F5A623]" data-testid="footer-support-link">
                                Assistance
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="overline text-white/60 mb-4">Légal</div>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/cgu" className="hover:text-[#F5A623]" data-testid="footer-cgu-link">
                                CGU / CGV
                            </Link>
                        </li>
                        <li>
                            <Link to="/mentions-legales" className="hover:text-[#F5A623]" data-testid="footer-mentions-link">
                                Mentions légales
                            </Link>
                        </li>
                        <li>
                            <Link to="/confidentialite" className="hover:text-[#F5A623]" data-testid="footer-privacy-link">
                                Confidentialité (RGPD)
                            </Link>
                        </li>
                        <li>
                            <Link to="/politique-annulation" className="hover:text-[#F5A623]" data-testid="footer-cancel-link">
                                Politique d'annulation
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="overline text-white/60 mb-4">Zones</div>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/recrutement-personnel-lyon" className="hover:text-[#F5A623]" data-testid="footer-seo-lyon">
                                Recrutement personnel Lyon
                            </Link>
                        </li>
                        <li>
                            <Link to="/recrutement-personnel-valence" className="hover:text-[#F5A623]" data-testid="footer-seo-valence">
                                Recrutement personnel Valence
                            </Link>
                        </li>
                        <li>
                            <Link to="/recrutement-personnel-grenoble" className="hover:text-[#F5A623]" data-testid="footer-seo-grenoble">
                                Recrutement personnel Grenoble
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="overline text-white/60 mb-4">Contact</div>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a href="mailto:contact@renforteo.fr" className="hover:text-[#F5A623]">
                                contact@renforteo.fr
                            </a>
                        </li>
                        <li className="text-white/60">Lun–Ven · 9 h – 18 h</li>
                        <li>
                            <Link to="/#contact" className="hover:text-[#F5A623]">
                                Formulaire de contact
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            {/* ========= MEGA SEO BLOCK — Lyon-first silo ========= */}
            <div className="border-t border-white/10 bg-[#0a1524]" data-testid="footer-seo-block">
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
                    <div>
                        <div className="overline text-[#F5A623] mb-4">Renfort restauration Lyon</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/recrutement-serveur-lyon" className="hover:text-[#F5A623]">Serveur extra Lyon</Link></li>
                            <li><Link to="/extra-restauration-lyon" className="hover:text-[#F5A623]">Extra restauration Lyon</Link></li>
                            <li><Link to="/renfort-restaurant-lyon" className="hover:text-[#F5A623]">Renfort restaurant Lyon</Link></li>
                            <li><Link to="/recrutement-chef-de-rang-lyon" className="hover:text-[#F5A623]">Chef de rang Lyon</Link></li>
                            <li><Link to="/recrutement-maitre-hotel-lyon" className="hover:text-[#F5A623]">Maître d'hôtel Lyon</Link></li>
                            <li><Link to="/recrutement-barman-lyon" className="hover:text-[#F5A623]">Barman Lyon</Link></li>
                            <li><Link to="/recrutement-commis-cuisine-lyon" className="hover:text-[#F5A623]">Commis de cuisine Lyon</Link></li>
                            <li><Link to="/recrutement-plongeur-lyon" className="hover:text-[#F5A623]">Plongeur Lyon</Link></li>
                            <li><Link to="/plongeur-professionnel-traiteur-lyon" className="hover:text-[#F5A623]">Plongeur professionnel traiteur Lyon</Link></li>
                            <li><Link to="/recrutement-cuisinier-lyon" className="hover:text-[#F5A623]">Cuisinier Lyon</Link></li>
                            <li><Link to="/recrutement-personnel-restaurant-urgence-lyon" className="hover:text-[#F5A623]">Renfort urgence Lyon</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline text-[#F5A623] mb-4">Événementiel Lyon</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/recrutement-hotesse-evenementielle-lyon" className="hover:text-[#F5A623]">Hôtesse événementielle Lyon</Link></li>
                            <li><Link to="/recrutement-hote-accueil-lyon" className="hover:text-[#F5A623]">Hôte d'accueil Lyon</Link></li>
                            <li><Link to="/recrutement-personnel-evenementiel-lyon" className="hover:text-[#F5A623]">Personnel événementiel Lyon</Link></li>
                            <li><Link to="/personnel-evenementiel-lyon" className="hover:text-[#F5A623]">Personnel événementiel Lyon</Link></li>
                            <li><Link to="/personnel-salon-lyon" className="hover:text-[#F5A623]">Personnel salon Lyon</Link></li>
                            <li><Link to="/personnel-salon-eurexpo-lyon" className="hover:text-[#F5A623]">Personnel Eurexpo Lyon</Link></li>
                            <li><Link to="/personnel-palais-congres-lyon" className="hover:text-[#F5A623]">Personnel Palais des Congrès Lyon</Link></li>
                        </ul>
                        <div className="overline text-[#F5A623] mb-4 mt-8">Hôtellerie Lyon</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/renfort-hotel-lyon" className="hover:text-[#F5A623]">Renfort hôtel Lyon</Link></li>
                            <li><Link to="/recrutement-femme-de-menage-hotel-lyon" className="hover:text-[#F5A623]">Femme de ménage hôtel Lyon</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline text-[#F5A623] mb-4">Nettoyage &amp; logistique Lyon</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/recrutement-agent-nettoyage-lyon" className="hover:text-[#F5A623]">Agent de nettoyage Lyon</Link></li>
                            <li><Link to="/agent-entretien-lyon" className="hover:text-[#F5A623]">Agent d'entretien Lyon</Link></li>
                            <li><Link to="/agent-nettoyage-bureaux-lyon" className="hover:text-[#F5A623]">Agent nettoyage bureaux Lyon</Link></li>
                            <li><Link to="/femme-menage-entreprise-lyon" className="hover:text-[#F5A623]">Femme de ménage entreprise Lyon</Link></li>
                            <li><Link to="/agent-entretien-copropriete-lyon" className="hover:text-[#F5A623]">Agent entretien copropriété Lyon</Link></li>
                            <li><Link to="/nettoyage-apres-evenement-lyon" className="hover:text-[#F5A623]">Nettoyage après événement Lyon</Link></li>
                            <li><Link to="/personnel-nettoyage-lyon" className="hover:text-[#F5A623]">Personnel nettoyage Lyon</Link></li>
                            <li><Link to="/recrutement-manutentionnaire-lyon" className="hover:text-[#F5A623]">Manutentionnaire Lyon</Link></li>
                            <li><Link to="/personnel-logistique-lyon" className="hover:text-[#F5A623]">Personnel logistique Lyon</Link></li>
                        </ul>
                        <div className="overline text-[#F5A623] mb-4 mt-8">Urgence Lyon</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/trouver-serveur-derniere-minute-lyon" className="hover:text-[#F5A623]">Serveur dernière minute</Link></li>
                            <li><Link to="/remplacement-salarie-absent-lyon" className="hover:text-[#F5A623]">Remplacement salarié absent</Link></li>
                            <li><Link to="/personnel-disponible-rapidement-lyon" className="hover:text-[#F5A623]">Personnel disponible rapidement</Link></li>
                            <li><Link to="/renfort-personnel-week-end-lyon" className="hover:text-[#F5A623]">Renfort week-end</Link></li>
                        </ul>
                        <div className="overline text-[#F5A623] mb-4 mt-8">Guides &amp; conseils</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/economie-vs-interim-lyon" className="hover:text-[#F5A623]">Économie vs intérim CHR Lyon</Link></li>
                            <li><Link to="/devenir-extra-serveur-lyon" className="hover:text-[#F5A623]">Devenir extra serveur Lyon</Link></li>
                            <li><Link to="/devenir-barman-independant-lyon" className="hover:text-[#F5A623]">Devenir barman indépendant</Link></li>
                            <li><Link to="/devenir-plongeur-traiteur-lyon" className="hover:text-[#F5A623]">Devenir plongeur traiteur</Link></li>
                            <li><Link to="/blog/devenir-serveur-lyon-guide" className="hover:text-[#F5A623]">Devenir serveur à Lyon (blog)</Link></li>
                            <li><Link to="/blog/renfort-service-evenementiel-guide" className="hover:text-[#F5A623]">Renfort service événementiel</Link></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline text-[#F5A623] mb-4">Métiers Renforteo</div>
                        <ul className="space-y-2 text-white/70">
                            <li><Link to="/metiers" className="hover:text-[#F5A623]">Tous les métiers</Link></li>
                            <li><Link to="/metiers/serveur" className="hover:text-[#F5A623]">Serveur</Link></li>
                            <li><Link to="/metiers/chef-de-rang" className="hover:text-[#F5A623]">Chef de rang</Link></li>
                            <li><Link to="/metiers/barman" className="hover:text-[#F5A623]">Barman</Link></li>
                            <li><Link to="/metiers/cuisinier" className="hover:text-[#F5A623]">Cuisinier</Link></li>
                            <li><Link to="/metiers/plongeur" className="hover:text-[#F5A623]">Plongeur</Link></li>
                            <li><Link to="/metiers/hotesse-accueil" className="hover:text-[#F5A623]">Hôtesse d'accueil</Link></li>
                            <li><Link to="/metiers/manutentionnaire" className="hover:text-[#F5A623]">Manutentionnaire</Link></li>
                            <li><Link to="/metiers/femme-de-menage" className="hover:text-[#F5A623]">Femme de ménage</Link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-white/50 flex flex-wrap justify-between gap-3">
                    <span>© {new Date().getFullYear()} Renforteo. Tous droits réservés.</span>
                    <span>Paiement sécurisé par Stripe · TVA incluse dans le devis</span>
                </div>
            </div>
        </footer>
    );
}
